import { createI18n } from 'vue-i18n'
import zh from './locales/zh-CN.json'
import en from './locales/en-US.json'

const messages = {
  'zh-CN': zh,
  'en-US': en
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: localStorage.getItem('language') || 'zh-CN', // 默认语言
  fallbackLocale: 'zh-CN', // 回退语言
  messages
})

export default i18n